import { render, staticRenderFns } from "./ChalanDesign.vue?vue&type=template&id=18535231&scoped=true&"
import script from "./ChalanDesign.vue?vue&type=script&lang=js&"
export * from "./ChalanDesign.vue?vue&type=script&lang=js&"
import style0 from "./ChalanDesign.vue?vue&type=style&index=0&id=18535231&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18535231",
  null
  
)

export default component.exports